import React, { useCallback, useRef, useState } from 'react'

import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'
import toLower from 'lodash/toLower'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import Button from '@galo-monitor/web-components/Button'
import Modal from '@galo-monitor/web-components/Modal'
import FertilizerManufacturerForm from '@galo-monitor/web-containers/forms/root/FertilizerManufacturerForm'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

const FertilizerManufacturerModal = (props) => {
  const {
    id,
    open,
    manufacturer,
    handleClose,
    onSuccess
  } = props

  const [loading, setLoading] = useState(false)

  const { createDialog } = useDialog()
  const t = useT()

  const formRef = useRef(null)

  const handleConfirm = useCallback(
    () => {
      formRef.current.submit()
    },
    []
  )

  const handleSuccess = useCallback(
    () => {
      handleClose()
      onSuccess()
    },
    [handleClose, onSuccess]
  )

  const onError = useCallback(
    ({ response }) => {
      setLoading(false)
      const { errors } = response.data
      const errorMessages = map(errors, error => (
        <React.Fragment key={ error.field }>
          {`${ t('error') }: ${ t('minLength validation failed') }.`}
          <br />
          {
            t('validation error message', {
              field: error.field,
              rule: error.rule
            })
          }.
          <br />
        </React.Fragment>
      ))

      createDialog({
        id: 'fertilizer-error',
        Component: ErrorModal,
        props: {
          title: `${ t('could not {action} the {this}', {
            howMany: 1,
            gender: 'male',
            action: toLower(t(manufacturer.id ? 'update' : 'register')),
            this: toLower(t('manufacturer', { howMany: 1 }))
          })  }.`,
          message: isEmpty(errorMessages) ? t('unexpected error occurred') : errorMessages
        }
      })
    },
    [createDialog, manufacturer.id, t]
  )

  return (
    <Modal
      id={ id }
      open={ open }
      loading={ loading }
      title={ t('register of {this}', { this: t('manufacturer', { howMany: 1 }) }) }
      maxWidth="xs"
      fullWidth
      FooterComponent={ () => (
        <>
          <Button
            id="save"
            onClick={ handleConfirm }
          >
            <I18n>save</I18n>
          </Button>
        </>
      ) }
    >
      <FertilizerManufacturerForm
        ref={ formRef }
        manufacturer={ manufacturer }
        onSuccess={ handleSuccess }
        onError={ onError }
        loading={ loading }
        setLoading={ setLoading }
      />
    </Modal>
  )
}

FertilizerManufacturerModal.propTypes = {
  id: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  manufacturer: PropTypes.object
}

FertilizerManufacturerModal.defaultProps = {
  manufacturer: {}
}

export default FertilizerManufacturerModal
